import deviceGroupingReducer from "./reducers";

export default deviceGroupingReducer;